import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmComplianceRoute: InvariantJiraRoute = {
	name: 'products-jsm-compliance',
	path: '/jira/settings/products/jira-service-management-compliance',
	exact: true,
};
